import { render, staticRenderFns } from "./AddressGroup.vue?vue&type=template&id=a7ea60ca&"
import script from "./AddressGroup.vue?vue&type=script&lang=js&"
export * from "./AddressGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports